import { css } from "@emotion/react";
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";
import { useTranslate } from "../../../hooks/useTranslate/useTranslate";
import { Badge } from "../../ui/badge";

export type ProductBrowserGridItemBarcodesProps = {
	product: ImmutableObject<Product>;
};
export const ProductBrowserGridItemBarcodes: React.FC<
	ProductBrowserGridItemBarcodesProps
> = (props) => {
	const product = props.product;
	const translate = useTranslate();

	return (
		<>
			{product.Barcodes && (
				<div className="field">
					<div className="caption">{translate("Barcodes")}:</div>
					<div className="value">
						{product.Barcodes?.split(",").map((tag) => (
							<span key={(product.Id || "") + tag}>
								{tag && (
									<Badge variant="outline" css={css`margin: .25em;`}>
										{tag}
									</Badge>
								)}
							</span>
						))}
					</div>
				</div>
			)}
		</>
	);
};
